module.exports = __webpack_public_path__ + "img/20180120_6.f4eb2775.jpeg";